// extracted by mini-css-extract-plugin
export default {"root":"UserHistoryDrawerAllCommentsQuery-root-72082059c840d4e2bb36e3ce91a5d4bb","callout":"UserHistoryDrawerAllCommentsQuery-callout-4209dce6edc8c462bcf031762ceb8b22"};